import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { usePageData } from '../../core'
import { KTSVG } from '../../../helpers'

const HeaderCurrentPage = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { pageTitle, pageBreadcrumbs } = usePageData()

  // Check if we're on a page that needs a back button
  const shouldShowBackButton = () => {
    const path = location.pathname
    return path.includes('/create') || path.includes('/edit') || path.includes('/detail')
  }

  // Get the parent route for back navigation
  const getBackRoute = () => {
    const path = location.pathname
    if (path.includes('/merchant-management/create')) {
      return '/merchant-management'
    }
    if (path.includes('/user-management/create')) {
      return '/user-management'
    }
    // Add more routes as needed
    return -1 // Default browser back
  }

  // Function to determine current page title based on route
  const getCurrentPageTitle = () => {
    const path = location.pathname
    
    // If pageTitle is set from PageTitle component, use it
    if (pageTitle) {
      return pageTitle
    }

    // Fallback: derive title from pathname - order matters!
    let title = 'Dashboard'
    switch (true) {
      case path.includes('/merchant-management/create'):
        title = 'Create New Merchant'
        break
      case path.includes('/user-management/create'):
        title = 'Create New User'
        break
      case path.includes('/user-management'):
        title = 'User Management'
        break
      case path.includes('/merchant-management'):
        title = 'Merchant Management'
        break
      case path.includes('/check-user-funds'):
        title = 'Check User Funds'
        break
      case path.includes('/user-funds'):
        title = 'User Funds'
        break
      case path.includes('/refunds'):
        title = 'Refunds'
        break
      case path.includes('/transaction-history'):
        title = 'Transaction History'
        break
      case path.includes('/transfers'):
        title = 'Transfers'
        break
      case path.includes('/homepage'):
        title = 'Homepage'
        break
      default:
        title = 'Dashboard'
    }
    
    return title
  }

  // Function to get icon based on current page
  const getCurrentPageIcon = () => {
    const path = location.pathname
    
    switch (true) {
      case path.includes('/user-management'):
        return '/media/icons/duotune/communication/com014.svg'
      case path.includes('/merchant-management'):
        return '/media/icons/duotune/ecommerce/ecm004.svg'
      case path.includes('/check-user-funds'):
        return '/media/icons/duotune/general/gen013.svg'
      case path.includes('/user-funds'):
        return '/media/icons/duotune/finance/fin008.svg'
      case path.includes('/refunds'):
        return '/media/icons/duotune/general/gen013.svg'
      case path.includes('/transaction-history'):
        return '/media/icons/duotune/finance/fin010.svg'
      case path.includes('/transfers'):
        return '/media/icons/duotune/finance/fin009.svg'
      case path.includes('/homepage'):
        return '/media/icons/duotune/general/gen025.svg'
      default:
        return '/media/icons/duotune/general/gen025.svg'
    }
  }

  return (
    <div className='d-flex align-items-center'>
      {/* Back Button - Show only on create/edit/detail pages */}
      {shouldShowBackButton() && (
        <button 
          className='btn btn-icon btn-light btn-sm me-4 shadow-sm hover-elevate-up d-flex align-items-center justify-content-center'
          onClick={() => {
            const backRoute = getBackRoute()
            if (typeof backRoute === 'string') {
              navigate(backRoute)
            } else {
              navigate(backRoute)
            }
          }}
          title="Go Back"
          style={{ 
            width: '40px', 
            height: '40px',
            borderRadius: '8px'
          }}
        >
          <KTSVG path='/media/icons/duotune/arrows/arr063.svg' className='svg-icon-3 text-gray-600' />
        </button>
      )}
      
      <div className='d-flex align-items-center me-4'>
        {/* Page Title and Breadcrumbs */}
        <div>
          <h1 className='page-heading d-flex text-dark fw-bold fs-2 flex-column justify-content-center my-0 mb-1'>
            {getCurrentPageTitle()}
          </h1>
          {pageBreadcrumbs && pageBreadcrumbs.length > 0 && (
            <div className='page-breadcrumb d-flex align-items-center fs-6 text-muted'>
              {pageBreadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={index}>
                  {breadcrumb.isSeparator ? (
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr071.svg'
                      className='svg-icon-7 text-muted mx-2'
                    />
                  ) : (
                    <span className={breadcrumb.isActive ? 'text-primary fw-semibold' : 'text-muted hover-text-primary cursor-pointer'}>
                      {breadcrumb.title}
                    </span>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export { HeaderCurrentPage }
